import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { NotificationAction } from 'types/notification'
import NotificationActions from "actions/Notification"
import { TypeOptionsBlock } from "./styles"

import { Dispatch } from 'redux'
import { useParams } from 'react-router-dom'
import { getResult, yesOrNoOptions } from './helper'

export default function PreviewResult({ accountabilityMatrix: matrix }) {
  const notificationDispatch: Dispatch<NotificationAction> = useDispatch<Dispatch<NotificationAction>>()
  const { id } = useParams()
  
  useEffect(() => {
    //@TODO: US-66215 - Optimização de multiplos requests
    //NotificationActions.getAccountabilityMatrixByNotificationId(notificationDispatch, id)
  }, [])


  return (
    <fieldset disabled={true}>
      <div id='result' className="flex flex-row mt-2" >
          <div className="mr-3 text-[#474747]/80">Resultado</div>
          <div className={getResult(matrix?.u_matrix_result)?.style}>
              <span className="text-white text-sm">
              {getResult(matrix?.u_matrix_result)?.description}
              </span>
          </div>
      </div>

      <div className="flex flex-row">
          <div className="w-[202px] flex justify-start items-baseline gap-3">
              <TypeOptionsBlock>Teste do ato deliberado</TypeOptionsBlock>
          </div>
          <div data-testid="test-toggle-button" className="mt-7 block min-h-[1.5rem] pl-[1.5rem]">
              <div className="z-20">
                  <legend className="font-semibold text-xs mb-3">
                      A ação foi intencional?
                  </legend>

                  <div className='flex items-center'>
              
                  {yesOrNoOptions.map((item) => (
                      <div className="mr-2 mb-3">
                        <input  key="u_question_01"
                                name="u_question_01"
                                checked={item.value === matrix?.u_question_01}
                                type="radio"
                                value={item.value}
                                readOnly
                                className={(item.value === matrix?.u_question_01 ? 
                                'border-gray-300 text-yellow' : 'border-gray-300 text-[#BDBDBD] bg-disabled')
                                .concat(' h-[16px] w-[16px] focus:ring-0 focus:ring-offset-0 mr-1') } />
                        <span className={(item.value === matrix?.u_question_01 ? '' : 'text-[#929292]').concat(' font-bold') }>{item.label}</span>
                  </div>
                  ))}
                  </div>
              </div>

              {matrix?.u_question_02 && (
              <div className="z-20">
                  <legend className="font-semibold text-xs mb-3">
                      As consequências do ato foram intencionais?
                  </legend>
                  <div  className='flex items-center'>
                  {yesOrNoOptions.map((item) => (
                      <div className="mr-2 mb-3">
                          <input  key="u_question_02"
                                  name="u_question_02"
                                  checked={item.value === matrix?.u_question_02} 
                                  type="radio"
                                  value={item.value}
                                  readOnly
                                  className={(item.value === matrix?.u_question_02 ? 
                                            'border-gray-300 text-yellow' : 'border-gray-300 text-[#BDBDBD] bg-disabled')
                                            .concat(' h-[16px] w-[16px] focus:ring-0 focus:ring-offset-0 mr-1') } />
                          <span className={(item.value === matrix?.u_question_02 ? '' : 'text-[#929292]').concat(' font-bold') }>{item.label}</span>
                      </div>
                      
                  ))}
                  </div>
              </div>
              )} 
          </div>
      </div>

    {matrix?.u_question_03  && (
        <div className="flex flex-row">
            <div className="w-[202px] flex justify-start items-baseline gap-3">
                <TypeOptionsBlock>Teste de incapacidade</TypeOptionsBlock>
            </div>
            <div data-testid="test-toggle-button-u_question_03" className="mt-7 block min-h-[1.5rem] pl-[1.5rem]">
                <div className="z-20">
                    <legend className="font-semibold text-xs mb-3">
                    O indivíduo está doente ou sob o uso de substâncias?
                    </legend>
                    <div  className='flex items-center'>
                        {yesOrNoOptions.map((item) => (
                        <div className="mr-2 mb-3">
                        <input key="u_question_03" 
                            name="u_question_03"
                            checked={item.value === matrix?.u_question_03}  
                            type="radio"
                            value={item.value}
                            readOnly
                            className={(item.value === matrix?.u_question_03 ? 
                            'border-gray-300 text-yellow' : 'border-gray-300 text-[#BDBDBD] bg-disabled')
                            .concat(' h-[16px] w-[16px] focus:ring-0 focus:ring-offset-0 mr-1') } />
                        <span className={(item.value === matrix?.u_question_03 ? '' : 'text-[#929292]').concat(' font-bold') }>{item.label}</span>
                        </div>
                        ))}
                    </div>
                </div>

                {matrix?.u_question_04 && (
                    <div className="z-20">
                        <legend className="font-semibold text-xs mb-3">
                        O uso de substâncias é justificável? 
                        </legend>
                        <div  className='flex items-center'>
                        {yesOrNoOptions.map((item) => (
                        <div className="mr-2 mb-3">
                        <input key="u_question_04" 
                            name="u_question_04"
                            checked={item.value === matrix?.u_question_04}  
                            type="radio"
                            value={item.value}
                            readOnly
                            className={(item.value === matrix?.u_question_04 ? 
                            'border-gray-300 text-yellow' : 'border-gray-300 text-[#BDBDBD] bg-disabled')
                            .concat(' h-[16px] w-[16px] focus:ring-0 focus:ring-offset-0 mr-1') } />
                        <span className={(item.value === matrix?.u_question_04 ? '' : 'text-[#929292]').concat(' font-bold') }>{item.label}</span>
                        </div>
                        ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    )}                   

    {matrix?.u_question_05  && (
        <div className="flex flex-row">
            <div className="w-[202px] flex justify-start items-baseline gap-3">
                <TypeOptionsBlock>Teste de "visão”</TypeOptionsBlock>
            </div>
            <div data-testid="test-toggle-button" className="mt-7 block min-h-[1.5rem] pl-[1.5rem]">
                <div className="z-20">
                    <legend className="font-semibold text-xs mb-3">
                    Havia um documento descrito que padronizasse a rotina (exemplo: POP, protocolo)?
                    </legend>
                    <div  className='flex items-center'>
                    {yesOrNoOptions.map((item) => (
                        <div className="mr-2 mb-3">
                        <input key="u_question_05" 
                            name="u_question_05"
                            checked={item.value === matrix?.u_question_05} 
                            type="radio"
                            value={item.value}
                            readOnly
                            className={(item.value === matrix?.u_question_05 ? 
                            'border-gray-300 text-yellow' : 'border-gray-300 text-[#BDBDBD] bg-disabled')
                            .concat(' h-[16px] w-[16px] focus:ring-0 focus:ring-offset-0 mr-1') } />
                        <span className={(item.value === matrix?.u_question_05 ? '' : 'text-[#929292]').concat(' font-bold') }>{item.label}</span>
                        </div>
                    ))}
                </div>
                </div>
                
                {matrix?.u_question_06 && (
                <div className="z-20">
                    <legend className="font-semibold text-xs mb-3">
                        Este documento estava disponível e de forma inteligível (fácil de compreender)?
                    </legend>  
                <div  className='flex items-center'>
                {yesOrNoOptions.map((item) => (
                    <div className="mr-2 mb-3">
                    <input key="u_question_06" 
                        name="u_question_06" 
                        checked={item.value === matrix?.u_question_06}
                        type="radio"
                        value={item.value}
                        readOnly
                        className={(item.value === matrix?.u_question_06 ? 
                        'border-gray-300 text-yellow' : 'border-gray-300 text-[#BDBDBD] bg-disabled')
                        .concat(' h-[16px] w-[16px] focus:ring-0 focus:ring-offset-0 mr-1') } />
                    <span className={(item.value === matrix?.u_question_06 ? '' : 'text-[#929292]').concat(' font-bold') }>{item.label}</span>
                    </div>
                ))}
                </div>      
                </div>
                )}

                {matrix?.u_question_07 && (
                <fieldset className="mt-4">
                    <legend className="font-semibold text-xs mb-3">
                    Há evidencias de violação consciente do procedimento de segurança?
                    </legend>  
                    <div  className='flex items-center'>
                        {yesOrNoOptions.map((item) => (
                            <div className="mr-2 mb-3">
                            <input key="u_question_07" 
                                name="u_question_07"
                                checked={item.value === matrix?.u_question_07}
                                type="radio"
                                value={item.value}
                                readOnly
                                className={(item.value === matrix?.u_question_07 ? 
                                'border-gray-300 text-yellow' : 'border-gray-300 text-[#BDBDBD] bg-disabled')
                                .concat(' h-[16px] w-[16px] focus:ring-0 focus:ring-offset-0 mr-1') } />
                            <span className={(item.value === matrix?.u_question_07 ? '' : 'text-[#929292]').concat(' font-bold') }>{item.label}</span>
                            </div>
                        ))}
                    </div>      
                </fieldset>
                )}  
                
            </div>
        </div>
    )} 

    {matrix?.u_question_08 && (
    <div className="flex flex-row">
            <div className="w-[202px] flex justify-start items-baseline gap-3">
            <TypeOptionsBlock>Teste de substituição</TypeOptionsBlock>
            </div>
            <div data-testid="test-toggle-button" className="mt-7 block min-h-[1.5rem] pl-[1.5rem]">
            <div className="z-20">
                <legend className="font-semibold text-xs mb-3">
                    Outro profissional com o mesmo cargo faria a mesma coisa?
                </legend>
                <div  className='flex items-center'>
                {yesOrNoOptions.map((item) => (
                    <div className="mr-2 mb-3">
                    <input key="u_question_08" 
                        name="u_question_08"
                        checked={item.value === matrix?.u_question_08}
                        type="radio"
                        value={item.value}
                        readOnly
                        className={(item.value === matrix?.u_question_08 ? 
                        'border-gray-300 text-yellow' : 'border-gray-300 text-[#BDBDBD] bg-disabled')
                        .concat(' h-[16px] w-[16px] focus:ring-0 focus:ring-offset-0 mr-1') } />
                    <span className={(item.value === matrix?.u_question_08 ? '' : 'text-[#929292]').concat(' font-bold') }>{item.label}</span>
                    </div>
                ))}
            </div>
            </div>
            
            {matrix?.u_question_09 && matrix?.u_question_08 === "no"  && (
            <div className="z-20">
                <legend className="font-semibold text-xs mb-3">
                Há falhas de treinamento do indivíduo ou ele era inexperiente?
                </legend>  
                <div  className='flex items-center'>
                {yesOrNoOptions.map((item) => (
                    <div className="mr-2 mb-3">
                    <input key="u_question_09" 
                        name="u_question_09"
                        checked={item.value === matrix?.u_question_09}
                        type="radio"
                        value={item.value}
                        readOnly
                        className={(item.value === matrix?.u_question_09 ? 
                        'border-gray-300 text-yellow' : 'border-gray-300 text-[#BDBDBD] bg-disabled')
                        .concat(' h-[16px] w-[16px] focus:ring-0 focus:ring-offset-0 mr-1') } />
                    <span className={(item.value === matrix?.u_question_09 ? '' : 'text-[#929292]').concat(' font-bold') }>{item.label}</span>
                    </div>
                ))}
                </div>      
            </div>
            )}

            </div>
    </div>
    )}

    {matrix?.u_question_10 && (
    <div className="flex flex-row">
            <div className="w-[202px] flex justify-start items-baseline gap-3">
            <TypeOptionsBlock>Histórico</TypeOptionsBlock>
            </div>
            <div data-testid="test-toggle-button" className="mt-7 block min-h-[1.5rem] pl-[1.5rem]">
                <div className="z-20">
                    <legend className="font-semibold text-xs mb-3">
                        Indivíduo possui histórico de atos inseguros?
                    </legend>
                    <div  className='flex items-center'>
                    {yesOrNoOptions.map((item) => (
                    <div className="mr-2 mb-3">
                    <input key="u_question_10" 
                            name="u_question_10"
                            checked={item.value === matrix?.u_question_10}
                            type="radio"
                            value={item.value}
                            readOnly
                            className={(item.value === matrix?.u_question_10 ? 
                            'border-gray-300 text-yellow' : 'border-gray-300 text-[#BDBDBD] bg-disabled')
                            .concat(' h-[16px] w-[16px] focus:ring-0 focus:ring-offset-0 mr-1') } />
                    <span className={(item.value === matrix?.u_question_10 ? '' : 'text-[#929292]').concat(' font-bold') }>{item.label}</span>
                    </div>
                    ))}
                </div>
                </div>
            </div>
    </div>
    )}

    {(matrix?.u_question_10 && matrix?.u_question_10 === "yes") && (
    <div className="flex flex-row">
        <div className="w-[202px] flex justify-start items-baseline gap-3">
            <TypeOptionsBlock>Teste de substituição</TypeOptionsBlock>
        </div>
        <div data-testid="test-toggle-button" className="mt-7 block min-h-[1.5rem] pl-[1.5rem]">                                         
        <div className="z-20">
            <legend className="font-semibold text-xs mb-3">
            Há falhas de treinamento do indivíduo ou ele era inexperiente?
            </legend>  
            <div  className='flex items-center'>
            {yesOrNoOptions.map((item) => (
            <div className="mr-2 mb-3">
                <input key="u_question_09" 
                        name="u_question_09"
                        checked={item.value === matrix?.u_question_09}
                        type="radio"
                        value={item.value}
                        readOnly
                        className={(item.value === matrix?.u_question_09 ? 
                        'border-gray-300 text-yellow' : 'border-gray-300 text-[#BDBDBD] bg-disabled')
                        .concat(' h-[16px] w-[16px] focus:ring-0 focus:ring-offset-0 mr-1') } />
                <span className="font-bold">{item.label}</span>
            </div>
            ))}
            </div>      
        </div>
        </div>
    </div>
    )}      

    </fieldset>
  )
}
